<template>
    <div></div>
</template>
<script>
export default {
    name: 'Redirect',
    mounted() {
        const { redirect = '/', ...query } = this.$route.query
        this.$router.replace({
            path: redirect,
            query
        })
    },
}
</script>
